import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Card,
  Divider,
  Thumbnail,
  Text,
  Title,
} from '@bb/elements-web';
import type { ListingConfigData } from 'components/ShowingSettingsModal';
import { featureEnabled, formatCurrency } from 'utils';

type Listing = ListingConfigData['listings'][number];

interface ListingComponentProps {
  listings: Listing[];
  onClick: (index?: number) => void;
}

const ActionItemWeb: React.FC<ListingComponentProps> = ({
  listings,
  onClick,
}) => (
  <StyledCard dataCy="action-items-card">
    {listings.map(
      (
        {
          line1,
          line2,
          city,
          province,
          postal_code,
          list_price,
          id,
          thumbnail,
        },
        index,
        array,
      ) => (
        <div key={id} data-cy={`action-item-${id}`}>
          <StyledItem>
            <Thumbnail
              src={thumbnail}
              size="medium"
              dataCy={`action-item-image-${id}`}
              square
            />
            <Title
              level={5}
              dataCy={`action-item-title-${id}`}
              style={{ margin: 0 }}
            >
              {line1}, {line2 && `${line2}, `}
              {city}, {province} {postal_code}
            </Title>

            <Text dataCy={`action-item-price-${id}`} size="large">
              {formatCurrency(list_price, { minimumFractionDigits: 2 })}
            </Text>

            <div>
              <Button
                onClick={() => onClick(index)}
                type="primary"
                dataCy={`add-access-button-${id}`}
              >
                Add access instructions
              </Button>
            </div>
          </StyledItem>
          {index !== array.length - 1 && <Divider marginSize="large" />}
        </div>
      ),
    )}
  </StyledCard>
);

const StyledCard = styled(Card)`
  max-width: 1180px;
`;

const StyledItem = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 20px 35px 1fr;
  gap: 8px 24px;
  justify-content: flex-start;
  align-items: flex-start;

  div:first-child {
    grid-row-end: span 3;
  }
`;

export default ActionItemWeb;
